import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { SectionHeader } from '../components/SectionHeader';
import { SectionInfoBanner } from '../components/SectionInfoBanner';
import { StoreTabFooter } from '../components/StoreTabFooter';
import {
  FOOD_FILTER_CATEGORY_OPTIONS,
  RELIGIOUS_FILTER_CATEGORY_OPTIONS,
  grid2,
} from '../storeSettingsConstants';

const checkboxSx = {
  padding: '4px 8px 4px 4px',
  color: '#c9ccd3',
  '&.Mui-checked': { color: 'rgb(24, 20, 54)' },
};

const capitalize = (value) => value.replace(/\b\w/g, (c) => c.toUpperCase());

function CategoryCheckboxGroup({ title, description, options, selected, onToggle }) {
  return (
    <div className='store-settings-list-block'>
      <div className='store-settings-list-header'>
        <div>
          <div style={{ fontSize: 14, fontWeight: 700, color: '#181436', marginBottom: 2 }}>
            {title}
          </div>
          {description && (
            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>{description}</div>
          )}
        </div>
        <span className='store-settings-count-badge'>
          {selected.length} / {options.length}
        </span>
      </div>

      <div style={grid2}>
        {options.map((option) => (
          <FormControlLabel
            key={option}
            control={
              <Checkbox
                checked={selected.includes(option)}
                onChange={() => onToggle(option)}
                sx={checkboxSx}
              />
            }
            label={capitalize(option)}
            sx={{ margin: 0, '& .MuiFormControlLabel-label': { fontSize: 14, color: '#181436' } }}
          />
        ))}
      </div>
    </div>
  );
}

export function FilterCategorySection({
  meta,
  form,
  toggleFoodFilterCategory,
  toggleReligiousFilterCategory,
  tabFooterProps,
}) {
  return (
    <>
      <SectionHeader Icon={meta.Icon} title={meta.title} subtitle={meta.subtitle} />

      <SectionInfoBanner title='What this tab controls'>
        <div>
          These filters help customers discover your store when browsing or searching by cuisine
          type or dietary/religious preference on the platform.
        </div>
      </SectionInfoBanner>

      <CategoryCheckboxGroup
        title='Filter categories'
        description='Select the categories that best describe your food.'
        options={FOOD_FILTER_CATEGORY_OPTIONS}
        selected={form.food_filter_categories}
        onToggle={toggleFoodFilterCategory}
      />

      <div style={{ height: 18 }} />

      <CategoryCheckboxGroup
        title='Religious / dietary categories'
        description='Select any dietary or religious certifications your store follows.'
        options={RELIGIOUS_FILTER_CATEGORY_OPTIONS}
        selected={form.religious_filter_categories}
        onToggle={toggleReligiousFilterCategory}
      />

      <StoreTabFooter tabId='8' {...tabFooterProps} />
    </>
  );
}
